module.exports = __webpack_public_path__ + "static/img/login_bg2.c416649.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/loginSuihua/img/login_bg2.jpg
// module id = hs85
// module chunks = 183